import React from "react";
import { FiAlertTriangle, FiRefreshCw } from "react-icons/fi";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, retryKey: 0 };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  handleRetry = () => {
    this.setState((state) => ({
      hasError: false,
      error: null,
      retryKey: state.retryKey + 1,
    }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <main
          className="tw-flex tw-min-h-[70vh] tw-items-center tw-justify-center tw-bg-dis-page tw-p-5 sm:tw-p-8"
          role="alert"
        >
          <section className="tw-w-full tw-max-w-xl tw-rounded-dis-card tw-border tw-border-dis-border tw-bg-white tw-p-6 tw-text-center tw-shadow-lg sm:tw-p-9">
            <div className="tw-mx-auto tw-mb-5 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-dis-error-bg tw-text-dis-error">
              <FiAlertTriangle className="tw-h-7 tw-w-7" aria-hidden="true" />
            </div>

            <p className="tw-m-0 tw-text-sm tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-dis-deep-blue">
              Something went wrong
            </p>
            <h1 className="tw-mb-3 tw-mt-2 tw-text-2xl tw-font-bold tw-text-dis-navy sm:tw-text-3xl">
              This page couldn’t load
            </h1>
            <p className="tw-mx-auto tw-mb-6 tw-mt-0 tw-max-w-md tw-text-base tw-leading-relaxed tw-text-dis-text-2">
              An unexpected issue interrupted this page. You can try rendering
              it again below.
            </p>

            <button
              type="button"
              onClick={this.handleRetry}
              className="tw-inline-flex tw-min-h-12 tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border-2 tw-border-dis-sky tw-bg-dis-sky tw-px-6 tw-text-base tw-font-bold tw-text-dis-navy tw-transition-colors hover:tw-border-dis-sky-hover hover:tw-bg-dis-sky-hover focus-visible:tw-outline-none focus-visible:tw-shadow-dis-focus"
            >
              <FiRefreshCw className="tw-h-4 tw-w-4" aria-hidden="true" />
              Try again
            </button>

            {this.state.error?.message && (
              <details className="tw-mt-6 tw-text-left">
                <summary className="tw-cursor-pointer tw-text-sm tw-font-semibold tw-text-dis-text-muted hover:tw-text-dis-navy">
                  Show error details
                </summary>
                <pre className="tw-mb-0 tw-mt-3 tw-max-h-40 tw-overflow-auto tw-whitespace-pre-wrap tw-break-words tw-rounded-lg tw-bg-dis-page tw-p-3 tw-text-xs tw-text-dis-text-2">
                  {this.state.error.message}
                </pre>
              </details>
            )}
          </section>
        </main>
      );
    }

    return (
      <React.Fragment key={this.state.retryKey}>
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default ErrorBoundary;
